import type { StateCreator } from 'zustand'

import type { Gateway } from '../../types/gateway.type'
import type { GatewaysActionsSlice, GatewaysFetchPatch, GatewaysStore } from '../types'

export const createGatewaysActionsSlice: StateCreator<
  GatewaysStore,
  [['zustand/immer', never]],
  [],
  GatewaysActionsSlice
> = (set) => ({
  setState: (patch: GatewaysFetchPatch) => set((state) => ({ ...state, ...patch })),

  setGateways: (gateways: Gateway[]) =>
    set((state) => {
      state.gateways = gateways
    }),

  setLoading: (loading: boolean) =>
    set((state) => {
      state.loading = loading
    }),

  setError: (error: string | null) =>
    set((state) => {
      state.error = error
    }),

  setLastFetchedProjectId: (projectId: string | null) =>
    set((state) => {
      state.lastFetchedProjectId = projectId
    }),
})
